import { useMutation } from '@tanstack/react-query';
import { GitlabClient } from '../httpClients/GitlabClient';
import { GitlabProvisioningProvisionRequest } from '../httpClients/GitlabClient/api.schema';
import { MUTATION_KEYS } from './consts';

/**
 * v2 wizard — starts async bot provisioning. Stateless: the same URL + PAT from
 * connect are re-sent in the body (never persisted between calls); the server
 * re-derives capability/scope authoritatively. Returns a `provisionId` to poll;
 * failures surface via the status query, so the Connect step owns error rendering
 * and this hook does not toast.
 * @returns TanStack mutation whose data holds the `provisionId` to poll.
 */
export const useGitlabProvisionMutation = () =>
  useMutation({
    mutationKey: [MUTATION_KEYS.GITLAB_PROVISION],
    mutationFn: (request: GitlabProvisioningProvisionRequest) =>
      GitlabClient.provision(request),
  });
